import { toggleIsLoading } from './loading';
import messageActions from './message';
import modalActions from './modal';
import cashierConstants from '../constants/cashier';
import cashierService from '../services/cashier';

const cashierCreate = (detail) => ({ type: cashierConstants.CREATE_CASHIER, detail })
const cashierList = (data) => ({ type: cashierConstants.LIST_CASHIER, data })
const cashierUpdate = (detail) => ({ type: cashierConstants.UPDATE_CASHIER, detail })
const cashierClear = () => ({ type: cashierConstants.CLEAR_CASHIER });

const cashierActions = {}

cashierActions.clearCashier = () => {
  return (dispatch) => {
    dispatch(cashierClear())
  }
}

cashierActions.list = (vendorApiKey, locationApiKey) => {
  return (dispatch) => {
    dispatch(toggleIsLoading(true));
    cashierService.list(vendorApiKey, locationApiKey)
    .then((response) => {
      dispatch(cashierList(response));
      dispatch(toggleIsLoading(false));
    })
    .catch((err) => {
      dispatch(toggleIsLoading(false));
      dispatch(messageActions.setErrorMessage(err.message));
    })
  }
}

cashierActions.create = (body, vendorApiKey, locationApiKey) => {
  return (dispatch) => {
    dispatch(toggleIsLoading(true));
    cashierService.create(body, vendorApiKey, locationApiKey)
    .then((response) => {
      dispatch(modalActions.modalToggle(false));
      dispatch(cashierCreate(response));
      dispatch(toggleIsLoading(false));
      dispatch(cashierActions.list(vendorApiKey, locationApiKey));
    })
    .catch((err) => {
      dispatch(toggleIsLoading(false));
      dispatch(messageActions.setErrorMessage(err.message));
    })
  }
}

cashierActions.update = (body, vendorApiKey, locationApiKey, cashierApiKey) => {
  return (dispatch) => {
    dispatch(toggleIsLoading(true));
    cashierService.update(body, vendorApiKey, locationApiKey, cashierApiKey)
    .then((response) => {
      dispatch(modalActions.modalToggle(false));
      dispatch(cashierUpdate(response));
      dispatch(toggleIsLoading(false));
      dispatch(cashierActions.list(vendorApiKey, locationApiKey));
    })
    .catch((err) => {
      dispatch(toggleIsLoading(false));
      dispatch(messageActions.setErrorMessage(err.message));
    })
  }
}


export default cashierActions;



/** WEBPACK FOOTER **
 ** ./src/actions/cashier.js
 **/